import Component from '../core/Component'
import { Loader } from 'google-maps'
import debounce from 'lodash/debounce'
import { GOOGLE_MAPS_API_KEY } from '../core/config'
import { createMarker } from './Marker'
import Scroll from '../services/Scroll'

const mapLoader = new Loader(GOOGLE_MAPS_API_KEY, {
    libraries: ['directions', 'places'],
    // language: 'cs',
    region: 'EU'
})

export const defaults = {
    zoom: 16,
    styles: [{"featureType":"all","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#8aa49f"},{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"visibility":"on"},{"gamma":"3.32"}]},{"featureType":"landscape.natural.landcover","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"transit.station","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]}]
}

export default class GoogleMap extends Component {

    constructor(element) {
        super(element)

        const options = this.element.dataset.options
        this.options = {
            ...defaults,
            ...(options ? JSON.parse(options) : {})
        }

        this.latlng = null
        this.isReady = false
        this.map = null

        this.handleDebouncedResize = debounce(this.handleResize, 200)
    }

    prepare() {
        mapLoader.load().then(this.handleGoogleMapsLoad)
        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
        this.map = null
    }

    handleResize = () => {
        this.center()
    }

    handleGoogleMapsLoad = google => {
        this.google = google

        this.render()
    }

    render() {
        const google = this.google

        const latlng = new google.maps.LatLng(this.options.lat, this.options.lng)
        this.latlng = latlng

        this.map = new google.maps.Map(this.element, {
            center: latlng,
            zoom: this.options.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: this.options.styles,
            disableDefaultUI: true,
            gestureHandling: 'cooperative'
        })

        const Marker = createMarker(google)

        const pin = new Marker({
            position: latlng,
            map: this.map
        })

        setTimeout(() => {
            this.isReady = true
            this.center()
        }, 0)
    }

    center() {
        if (this.isReady) {
            this.google.maps.event.trigger(this.map,'resize')
            this.map.setCenter(this.latlng)
        }
    }
}